/* eslint-disable react/jsx-no-useless-fragment */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { process } from "@progress/kendo-data-query";
import { Card, CardBody, Flex } from "@chakra-ui/react";
import { FaEdit } from "react-icons/fa";
import { useUser } from "../../hooks/use-user";
import { Paths } from "../../routes/paths";
import { HasPermission } from "../../utils/helper";
import { useGetCurrencyList } from "../../services/currency-api";
import { initialDataState } from "./constants";
import CurrencyFilterBarV2 from "components/currencies/filter-bar";
import Loader from "components/PageLoader";

export default function CurrencyList() {
  const [currencies, setCurrencies] = useState([]);
  const [dataState, setDataState] = useState(initialDataState);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);

  const [filters, setFilters] = useState({
    searchCriteria: "",
  });
  const user = useUser();
  const pageSize = 25;
  const {
    mutate: getCurrenciesList,
    isSuccess: currenciesListAvailable,
    data: currenciesList,
    isPending: gettingCurrenciesList,
    reset: resetCurrenciesListError,
  } = useGetCurrencyList();

  useEffect(() => {
    if (currenciesListAvailable) {
      setCurrencies(currenciesList.data.data);
      setTotalRecords(currenciesList.data.totalRecords);
      resetCurrenciesListError();
    }
  }, [currenciesListAvailable]);

  useEffect(() => {
    setCurrentPage(1);
    getCurrenciesList({
      pageNumber: 1,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
    });
  }, [filters]);

  const onPageChange = (e) => {
    const _page = e.page.skip / pageSize + 1;
    setCurrentPage(_page);
    getCurrenciesList({
      pageNumber: _page,
      pageRowCount: pageSize,
      searchCriteria: filters.searchCriteria,
    });
  };

  const viewCell = ({ dataItem }) => {
    return (
      <>
        {canViewDetails ? (
          <td>
            <Flex
              as={Link}
              to={`${Paths.currencyDetails}/${dataItem.currencyId}`}
              style={{ cursor: "pointer", color: "blue" }}
              w="100%"
              title="View"
            >
              <>{dataItem.name}</>
            </Flex>
          </td>
        ) : (
          <>{dataItem.name}</>
        )}
      </>
    );
  };

  const editCell = ({ dataItem }) => {
    return (
      <td>
        <Flex
          as={Link}
          to={`${Paths.currencyEdit}/${dataItem.currencyId}`}
          justifyContent="center"
          style={{ cursor: "pointer" }}
          w="100%"
          title="Edit Currencies"
        >
          <FaEdit fontSize="18px" color="var(--primary-dark)" />
        </Flex>
      </td>
    );
  };

  const canEdit = useMemo(() => {
    return HasPermission(user, "Currency", "Edit");
  }, [user]);

  const canViewDetails = useMemo(() => {
    return HasPermission(user, "Currency", "View");
  }, [user]);

  return (
    <Flex className="main-container">
      {gettingCurrenciesList ? <Loader /> : <></>}
      <Card m="20px">
        <CardBody>
          <CurrencyFilterBarV2
            getList={(filter) => {
              setFilters({
                searchCriteria: filter,
              });
            }}
          />
          <Grid
            data={process(currencies || [], dataState)}
            {...dataState}
            onDataStateChange={(e) => {
              setDataState(e.dataState);
            }}
            filterable
            sortable
            pageable
            total={totalRecords}
            pageSize={pageSize}
            skip={(currentPage - 1) * pageSize}
            onPageChange={onPageChange}
          >
            <Column title="Name" field="name" cell={viewCell} width={200} />
            <Column title="Short Name" field="shortName" />
            <Column title="Symbol" field="symbol" />
            <Column title="Type" field="type" />

            {canEdit > 0 ? (
              <Column
                filterable={false}
                title="Edit"
                headerClassName="text-center"
                className="text-center"
                width={80}
                cell={editCell}
              />
            ) : (
              <></>
            )}
            {/* {canDelete ? (
                <Column
                  filterable={false}
                  title="Delete"
                  headerClassName="text-center"
                  className="text-center"
                  width={80}
                  cell={deleteCell}
                />
              ) : (
                <></>
              )} */}
          </Grid>
        </CardBody>
      </Card>
    </Flex>
  );
}
